import React, { useState } from 'react';
import { Badge, useDisclosure, Spinner, Box, Tooltip, HStack, Text, useToast } from '@chakra-ui/react';
import { CheckCircleIcon, WarningTwoIcon, QuestionOutlineIcon } from '@chakra-ui/icons';
import { getDetalhesConferencia } from '../../services/api';
import { DetalhesConferenciaModal } from '../DetalhesConferenciaModal';

const VERIFICADO = { color: 'green', icon: <CheckCircleIcon />, text: 'Verificado' };
const statusConfig = {
    0: { color: 'gray', icon: <QuestionOutlineIcon />, text: 'Pendente' },
    1: VERIFICADO,
    2: { color: 'red', icon: <WarningTwoIcon />, text: 'Com Problema' },
    3: VERIFICADO,
    4: VERIFICADO,
    5: VERIFICADO,
};

const StatusConferenciaBadge = ({ status, vendaId, produtoEstoqueId, renderizar }) => {
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isLoading, setIsLoading] = useState(false);
    const [detalhes, setDetalhes] = useState(null);
    const toast = useToast(); // Adicionado hook para o toast

    const config = statusConfig[status] || statusConfig[0];

    const handleClick = async () => {
        if (!status || status === 0) return; // Não faz nada se o status for "Pendente"

        setIsLoading(true);
        const data = await getDetalhesConferencia(vendaId, produtoEstoqueId);
        if (data) {
            setDetalhes(data);
            onOpen();
        } else {
            toast({
                title: "Detalhes não encontrados",
                description: "Nenhum registro de conferência foi encontrado para este item.",
                status: "error",
                duration: 5000,
                isClosable: true,
                position: "top",
            });
        }
        setIsLoading(false);
    };

    if (renderizar) {
        return (
            <>
                {renderizar({ status: Number(status) || 0, scheme: config.color, texto: config.text, clicavel: !!status && status !== 0, carregando: isLoading, onClick: handleClick })}
                <DetalhesConferenciaModal isOpen={isOpen} onClose={onClose} detalhes={detalhes} />
            </>
        );
    }

    return (
        <Box>
            <Tooltip label={config.text} placement="top" hasArrow>
                <Badge
                    mt={1}
                    fontSize="10px"
                    colorScheme={config.color}
                    variant="solid"
                    borderRadius="md"
                    cursor={status && status !== 0 ? 'pointer' : 'default'}
                    onClick={handleClick}
                    textAlign="center"
                >
                    <HStack justify="center" align="center" spacing={1.5}>
                        {isLoading ? <Spinner size="xs" /> : config.icon}
                        <Text as="span" fontSize="8px" fontWeight="bold">
                            Conferência
                        </Text>
                    </HStack>
                </Badge>
            </Tooltip>

            <DetalhesConferenciaModal
                isOpen={isOpen}
                onClose={onClose}
                detalhes={detalhes}
            />
        </Box>
    );
};

export default StatusConferenciaBadge;
